import { useContext } from "react";
import { AuthenticationContext } from "../../shared/providers/authentication/authentication.provider";
import { TranslationContext } from "../../shared/providers/translation/translation.provider";

function ProfilePicture() {
    const { user } = useContext(AuthenticationContext);
    const { translate } = useContext(TranslationContext);
    return (
        <div className="profile">
            <figure className="profile_thumbnail">
                <img
                    src={`https://api.dicebear.com/9.x/avataaars/svg?seed=${new Date().getDay()}&backgroundColor=ffd5dc&eyes=happy&facialHair[]&mouth=smile&skinColor=614335,ae5d29,d08b5b,ffdbb4,edb98a`}
                    alt={user?.name}
                />
            </figure>
            <div className="profile_info">
                <span className="text-bd3-rg color-neutrals-black">
                    {user?.firstName ? `${user?.firstName} ${user?.lastName}` : user?.email}
                </span>
                <span className="text-bd3-light color-neutrals-neutral">{translate(`account.role.${user?.jobTitle.code}`, user?.jobTitle.code ?? "")}</span>
            </div>
        </div>
    );
}

export default ProfilePicture;
